import Segment from 'helpers/segment';

import { SKU_ANALYTICS_EVENTS } from 'features/Sku/Items/SkuAnalytics.constants';
import useSkuVenuePermissions from 'features/Sku/Items/useSkuVenuePermissions';

const useModifierAnalytics = ({ venueId }) => {
  const { source } = useSkuVenuePermissions();

  const track = (event, properties) => Segment.event(event, { venueId, source, ...properties });

  const trackGroupAvailabilityChanged = ({ groupId, from, to }) =>
    track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_AVAILABILITY_CHANGED, { groupId, from, to });

  const trackGroupDeleted = ({ groupId }) => track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_DELETED, { groupId });

  const trackEditorOpened = ({ mode, groupId }) =>
    track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_EDITOR_OPENED, { mode, groupId });

  const trackGroupSaved = ({
    groupId,
    isNew,
    duplicatedFrom,
    optionCount,
    optionsAdded,
    optionsUpdated,
    optionsRemoved,
    groupFieldsChanged,
    reordered,
    itemsAdded,
    itemsRemoved,
  }) => {
    if (isNew && duplicatedFrom) {
      track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_DUPLICATED, { groupId, sourceGroupId: duplicatedFrom, optionCount });
    } else if (isNew) {
      track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_CREATED, { groupId, optionCount });
    } else if (groupFieldsChanged || optionsAdded || optionsUpdated || optionsRemoved) {
      track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_EDITED, { groupId, optionsAdded, optionsUpdated, optionsRemoved });
    }

    if (reordered) track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_REORDERED, { groupId, optionCount });

    itemsAdded.forEach(itemId => track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_ITEM_ADDED, { groupId, itemId }));
    itemsRemoved.forEach(itemId => track(SKU_ANALYTICS_EVENTS.MODIFIER_GROUP_ITEM_REMOVED, { groupId, itemId }));
  };

  return { trackEditorOpened, trackGroupAvailabilityChanged, trackGroupDeleted, trackGroupSaved };
};

export default useModifierAnalytics;
